export default "__VITE_ASSET__o4bm_zqu__"